import { render, staticRenderFns } from "./TrustSafety.vue?vue&type=template&id=27c7416e&scoped=true"
import script from "./TrustSafety.vue?vue&type=script&lang=js"
export * from "./TrustSafety.vue?vue&type=script&lang=js"
import style0 from "./TrustSafety.vue?vue&type=style&index=0&id=27c7416e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c7416e",
  null
  
)

export default component.exports